import { connect, JSONCodec } from 'nats.ws';
import { useNats } from '~/composables/main';
import type { ModelConversationDetail, ModelConversationDetailProcess } from '~/services/conversation/dto/conversation.detail.dto';
import { convertMarkdownToHtml } from './functions/display';

export default defineNuxtPlugin((nuxtApp) => {
  const runtimeConfig = useRuntimeConfig();
  return {
    provide: {
      nats: {
        // connect: async () => {
        //   const gNats = useNats()
        //   console.log('runtimeConfig.public.natsHost', runtimeConfig.public.natsHost)
        //   gNats.value = await connect({
        //     servers: [runtimeConfig.public.natsHost],
        //     user: runtimeConfig.public.natsUsername as string,
        //     pass: runtimeConfig.public.natsPassword as string,
        //   })
        // },
        subscribe: async (data: ModelConversationDetail, callback = () => { }) => {
          const gConversationData = useConversationData();
          const gServiceData = useServiceData();
          const gPresetData = usePresetData();
          const gConversationActiveId = useConversationActiveId();
          const gIsDuringAIMessage = useIsDuringAIMessage();
          const gNats = useNats()
          const { $functions } = useNuxtApp()
          gConversationData.value = data;
          gConversationData.value = $functions.initVersionConversationMessage(gConversationData.value)

          gPresetData.value = await gServiceData.value.getPresetDetail()

          try {
            console.log("subscribe", `llm.conv.${gConversationData.value.id}`, gNats.value);
            gConversationData.value.natSubscribeValue = gNats.value.subscribe(`llm.conv.${gConversationData.value.id}`);
            await callback()

            for await (const message of gConversationData.value.natSubscribeValue) {
              const data = JSONCodec().decode(message.data) as any;
              console.log(`Received message on topic ${message.subject}:`, data);
              switch (data.eventType) {
                case 'message-agent':
                case 'message-output':
                  break;
                case 'message-start':
                case 'message-end':
                case 'message-stream':
                  gConversationData.value.conversationMessageList = gConversationData.value.conversationMessageList.map(e => {
                    if (
                      e.id === data.conversationMessageId
                    ) {
                      if (data.value.text) {
                        e.aiMessage = convertMarkdownToHtml(`${e.aiMessage || ''}${data.value.text}`)
                        e.aiMessageList.push(data.value.text)
                        e.isNewAIMessage = true
                      }
                      if (data.eventType === 'message-end') {
                        e.aiMessage = convertMarkdownToHtml(e.aiMessage || '', {
                          isEndStream: true
                        })
                        e.isEndStream = true
                        e.isMaxToken = data.value.isMaxToken || false;
                      }
                    }
                    else {
                      e.isNewAIMessage = false
                    }
                    return e;
                  })

                  if (data.eventType === 'message-end') {
                    // setTimeout(() => {
                    //   Prism.highlightAll();
                    // }, 100);
                    gIsDuringAIMessage.value = false;
                  }
                  break;
                case 'title':
                  gConversationActiveId.value = gConversationData.value.id
                  await gServiceData.value.getConversarion()
                  break;
                case 'message-event':
                  gConversationData.value.conversationMessageList = gConversationData.value.conversationMessageList.map(e => {
                    if (
                      e.id === data.conversationMessageId
                    ) {
                      let isReplace = false
                      e.processList = e.processList.map((ep: ModelConversationDetailProcess) => {
                        if (
                          (ep.title || '').toLowerCase() === (data.value.title || '').toLowerCase() &&
                          e.processPreviousTitle === data.value.title
                        ) {
                          ep = data.value;
                          isReplace = true
                        }
                        return ep
                      })
                      if (!isReplace) {
                        e.processList.push(data.value)
                      }

                      e.processPreviousTitle = data.value.title
                    }
                    return e;
                  })
                  break;
              }
            }
          } catch (error) {
            console.error("Failed to connect to NATS WebSocket server:", error);
          }
        },
        unsubscribe: () => {
          const gConversationData = useConversationData();
          try {
            if (gConversationData.value.natSubscribeValue) {
              gConversationData.value.natSubscribeValue.unsubscribe(); // Unsubscribe from the subject
              console.log('Unsubscribed from', gConversationData.value.id);
              gConversationData.value.natSubscribeValue = null; // Clear the subscription reference
              console.log('Unsubscribed value', gConversationData.value.natSubscribeValue);
            }
          } catch (error) {
            console.error("Failed to Unsubscribed to NATS WebSocket server:", error);
          }
        }
      }
    }
  }
});